import { render, staticRenderFns } from "./VacationsList.vue?vue&type=template&id=80d457de&scoped=true"
import script from "./VacationsList.vue?vue&type=script&lang=js"
export * from "./VacationsList.vue?vue&type=script&lang=js"
import style0 from "./VacationsList.vue?vue&type=style&index=0&id=80d457de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d457de",
  null
  
)

export default component.exports